var _rect, _g, _rect2, _path, _path2, _path3, _rect3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDerivativeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 280,
    viewBox: "0 0 190 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 190,
    height: 260,
    rx: 1,
    fill: "#171923"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_11959_314258)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 150,
    height: 220,
    rx: 1,
    fill: "#2D3748"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 180,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 14.2857H131.429V50H60V14.2857H81.4286C81.4286 6.39593 87.8245 0 95.7143 0C103.604 0 110 6.39593 110 14.2857Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.727 91.4453C112.45 91.4453 112.227 91.6692 112.227 91.9453V162.556H125.56V91.9453C125.56 91.6692 125.336 91.4453 125.06 91.4453H112.727ZM77.1602 109.219C76.884 109.219 76.6602 109.443 76.6602 109.719V162.552H89.9935V109.719C89.9935 109.443 89.7696 109.219 89.4935 109.219H77.1602ZM58.8672 140.832C58.8672 140.556 59.091 140.332 59.3672 140.332H71.7005C71.9767 140.332 72.2005 140.556 72.2005 140.832V162.554H58.8672V140.832ZM50 164.781C50 163.554 50.9949 162.559 52.2222 162.559H94.4336V127.512C94.4336 127.236 94.6575 127.012 94.9336 127.012H107.267C107.543 127.012 107.767 127.236 107.767 127.512V162.559H127.778C129.005 162.559 130 163.554 130 164.781C130 166.008 129.005 167.003 127.778 167.003H52.2222C50.9949 167.003 50 166.008 50 164.781Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.585 64.2254C112.585 65.629 113.269 66.8728 114.322 67.6412L101.042 95.785C100.705 95.6983 100.352 95.6522 99.9872 95.6522C99.0614 95.6522 98.2051 95.9499 97.5089 96.4549L82.5235 82.3403L82.5723 82.2619C82.9604 81.623 83.184 80.873 83.184 80.0709C83.184 77.7372 81.2922 75.8454 78.9585 75.8454C76.6249 75.8454 74.7331 77.7372 74.7331 80.0709C74.7331 81.3159 75.2716 82.4352 76.1283 83.2085L63.6117 103.84C63.1522 103.669 62.6548 103.575 62.1356 103.575C59.802 103.575 57.9102 105.467 57.9102 107.8C57.9102 110.134 59.802 112.026 62.1356 112.026C64.4692 112.026 66.361 110.134 66.361 107.8C66.361 106.555 65.8226 105.436 64.9658 104.663L77.4825 84.0313C77.942 84.2026 78.4393 84.2963 78.9585 84.2963C79.8844 84.2963 80.7407 83.9985 81.4369 83.4935L96.4223 97.6082C96.4057 97.6341 96.3895 97.6603 96.3735 97.6866C95.9853 98.3254 95.7618 99.0754 95.7618 99.8776C95.7618 102.211 97.6536 104.103 99.9872 104.103C102.321 104.103 104.213 102.211 104.213 99.8776C104.213 98.474 103.528 97.2303 102.475 96.4618L115.755 68.3181C116.092 68.4048 116.446 68.4509 116.81 68.4509C119.144 68.4509 121.036 66.5591 121.036 64.2254C121.036 61.8918 119.144 60 116.81 60C114.476 60 112.585 61.8918 112.585 64.2254Z",
    fill: "#A0AEC0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 190,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 247.01C106.046 247.01 115 238.055 115 227.01C115 215.964 106.046 207.01 95 207.01C83.9543 207.01 75 215.964 75 227.01C75 238.055 83.9543 247.01 95 247.01ZM88.8357 236.157C89.5106 236.959 90.4484 237.421 91.4126 237.421C92.3735 237.42 93.3103 236.957 93.9818 236.156L105.431 222.514C106.262 221.522 106.252 219.926 105.41 218.948C104.565 217.969 103.208 217.98 102.375 218.972L91.4074 232.041L86.6794 226.409C85.8492 225.418 84.4899 225.408 83.6459 226.386C82.8028 227.362 82.7943 228.959 83.6255 229.951L88.8357 236.157Z",
    fill: "#10B981"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_11959_314258",
    x: -12.2667,
    y: 7.73333,
    width: 214.533,
    height: 284.533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_11959_314258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_11959_314258",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerivativeLogo);
export default __webpack_public_path__ + "static/media/DerivativeLogo.858ecf057e7255305cf6d87022b69871.svg";
export { ForwardRef as ReactComponent };